var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-inline"},[_c('i',{staticClass:"fa fa-info-circle info-btn",attrs:{"id":_vm.id}}),_c('b-tooltip',{attrs:{"target":_vm.id,"custom-class":"data-info-tooltip"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.info)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }